export const formatHistoryEntry = (entry, formatDateTime, getUserLabel) => {
    if (!entry) return '';
    const actionMap = {
        'task.create': 'Создана задача',
        'task.update': 'Обновлена задача',
        'task.status': 'Смена статуса',
        'task.delete': 'Удалена задача'
    };
    const fieldMap = {
        title: 'Тема',
        description: 'Описание',
        start_at: 'Начало',
        due_at: 'Крайний срок',
        tags: 'Теги',
        assignee_id: 'Главный исполнитель',
        created_by_id: 'Постановщик',
        workspace_id: 'Проект',
        cabinets: 'Кабинеты'
    };
    const actionLabel = actionMap[entry.action] || entry.action;
    const fields = (entry.fields_changed || []).map((field) => fieldMap[field] || field);
    const fieldsLabel = fields.length ? `: ${fields.join(', ')}` : '';
    return `${actionLabel}${fieldsLabel}`;
};

export const canEditTaskDates = (task, user) => {
    if (!task || !user) return false;
    return user.role === 'admin' || task.created_by_id === user.id;
};

export const canChangeStatus = (task, nextStatus, user) => {
    if (!task || !user) return false;
    const participants = task.participants || [];
    const current = participants.find((item) => item.user?.id === user.id);
    const role = current?.role;
    const isSuper = user.role === 'admin';
    const isAssignee = task.assignee_id === user.id;
    if (isSuper) return true;
    if (task.status === 'created' && nextStatus === 'in_progress') return role === 'assignee' || isAssignee;
    if (task.status === 'in_progress' && nextStatus === 'review') return role === 'assignee' || isAssignee;
    if (task.status === 'review' && nextStatus === 'done') return role === 'creator';
    if (task.status === 'review' && nextStatus === 'rejected') return role === 'creator';
    if (task.status === 'rejected' && nextStatus === 'in_progress') return role === 'assignee' || isAssignee;
    return false;
};

export const handleKanbanDragStart = (event, taskId) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', taskId);
    event.stopPropagation();
};

export const handleKanbanDrop = async ({
    event,
    columnKey,
    filteredTasks,
    kanbanGroup,
    canChangeStatus,
    canEditTaskDates,
    handleStatusChange,
    handleUpdateTaskFields,
    showStatus
}) => {
    event.preventDefault();
    const taskId = event.dataTransfer.getData('text/plain');
    if (!taskId) return;
    const task = filteredTasks.find((item) => item.id === taskId);
    if (!task) return;

    if (kanbanGroup === 'status') {
        if (!canChangeStatus(task, columnKey)) {
            showStatus('error', 'Недостаточно прав для изменения статуса.');
            return;
        }
        await handleStatusChange(taskId, columnKey);
        return;
    }

    if (kanbanGroup === 'date') {
        if (!canEditTaskDates(task)) {
            showStatus('error', 'Недостаточно прав для изменения срока.');
            return;
        }
        let dueAt = null;
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 18, 0, 0);
        if (columnKey === 'today') {
            dueAt = today;
        } else if (columnKey === 'tomorrow') {
            dueAt = new Date(today.getTime() + 86400000);
        } else if (columnKey === 'week') {
            dueAt = new Date(today.getTime() + 3 * 86400000);
        } else if (columnKey === 'later') {
            dueAt = new Date(today.getTime() + 10 * 86400000);
        } else if (columnKey === 'overdue') {
            dueAt = new Date(today.getTime() - 86400000);
        }
        await handleUpdateTaskFields(taskId, { due_at: dueAt ? dueAt.toISOString() : null });
    }
};
